import React, { useState, useEffect, useContext } from 'react';
import './FaqAccordion.scss';
import { Accordion, Form } from 'react-bootstrap';
import { LayoutDetailsContext } from '../../../Project/Layouts/LayoutDetailsContext';

const FaqAccordion = (props) => {
  const [activeCategoryIndex, setActiveCategoryIndex] = useState(0);
  const [isMobileView, setIsMobileView] = useState(false);
  const [activeAccordionItems, setActiveAccordionItems] = useState(
    new Array(props?.fields?.items?.length).fill('0')
  );
  const brandName = useContext(LayoutDetailsContext);

  useEffect(() => {
    if (typeof window !== 'undefined' && !!window) {
      const handleResize = () => {
        setIsMobileView(window.innerWidth <= 768);
      };

      window.addEventListener('resize', handleResize);
      handleResize();

      return () => window.removeEventListener('resize', handleResize);
    }
  }, []);

  const handleAccordionToggle = (categoryIndex, accordionIndex) => {
    const updatedActiveItems = [...activeAccordionItems];
    const currentAccordionIndex = updatedActiveItems[categoryIndex];
    const isExpanding = currentAccordionIndex !== accordionIndex.toString();

    updatedActiveItems[categoryIndex] = isExpanding ? accordionIndex.toString() : null;

    setActiveAccordionItems(updatedActiveItems);

    const categoryTitle = props?.fields?.items[categoryIndex]?.fields?.FaqCategoryTitle?.value;
    const faqQuestion =
      props?.fields?.items[categoryIndex]?.fields?.FaqItems[accordionIndex]?.fields?.Question
        ?.value;

    dataLayer.push({
      event: 'faq_interaction',
      faq_title: faqQuestion,
      section_name: categoryTitle,
      iteraction_type: isExpanding ? 'expand' : 'collapse',
      BrandName: 'TVS iQube',
      VariantName: brandName,
    });
  };

  const handleCategoryChange = (index) => {
    setActiveCategoryIndex(index);

    const categoryTitle = props?.fields?.items[index]?.fields?.FaqCategoryTitle?.value;
    dataLayer.push({
      event: 'select_faq',
      cta_text: categoryTitle,
      BrandName: 'TVS iQube',
      VariantName: brandName,
    });
  };

  return (
    <div className="faq-container commonContainer" data-aos="fade-up">
      <div className="faq-header-section">
        <h2 className="faq-header">FAQs</h2>
      </div>
      {isMobileView ? (
        <>
          <div className="faq-content-mobile">
            <Form.Select
              aria-label="Select FAQ Category"
              value={activeCategoryIndex}
              onChange={(e) => handleCategoryChange(Number(e.target.value))}
            >
              {props?.fields?.items?.map((field, index) => (
                <option key={index} value={index}>
                  {field?.fields?.FaqCategoryTitle?.value}
                </option>
              ))}
            </Form.Select>
          </div>

          <div className="faq-mobile-content">
            {props?.fields?.items[activeCategoryIndex]?.fields?.FaqItems?.map((faq, index) => (
              <Accordion
                key={index}
                activeKey={
                  activeAccordionItems[activeCategoryIndex] === index.toString()
                    ? index.toString()
                    : null
                }
                onSelect={() => handleAccordionToggle(activeCategoryIndex, index.toString())}
              >
                <Accordion.Item eventKey={index.toString()}>
                  <Accordion.Header className="roboto-medium">
                    {faq?.fields?.Question?.value}
                  </Accordion.Header>
                  <Accordion.Body
                    dangerouslySetInnerHTML={{ __html: faq?.fields?.Answer?.value }}
                  />
                </Accordion.Item>
              </Accordion>
            ))}
          </div>
        </>
      ) : (
        <div className="faq-content">
          <div className="faq-left">
            <Accordion defaultActiveKey="0" flush>
              {props?.fields?.items?.map((field, index) => (
                <Accordion.Item
                  eventKey={index.toString()}
                  key={index}
                  onClick={() => handleCategoryChange(index)}
                >
                  <Accordion.Header
                    className={`main-header ${activeCategoryIndex === index ? 'active' : ''}`}
                  >
                    {field?.fields?.FaqCategoryTitle?.value}
                  </Accordion.Header>
                </Accordion.Item>
              ))}
            </Accordion>
          </div>

          <div className="faq-right">
            {props?.fields?.items[activeCategoryIndex]?.fields?.FaqItems?.map((faq, index) => (
              <Accordion
                key={index}
                activeKey={
                  activeAccordionItems[activeCategoryIndex] === index.toString()
                    ? index.toString()
                    : null
                }
                onSelect={() => handleAccordionToggle(activeCategoryIndex, index.toString())}
              >
                <Accordion.Item eventKey={index.toString()}>
                  <Accordion.Header className="roboto-medium">
                    {faq?.fields?.Question?.value}
                  </Accordion.Header>
                  <Accordion.Body
                    dangerouslySetInnerHTML={{ __html: faq?.fields?.Answer?.value }}
                  />
                </Accordion.Item>
              </Accordion>
            ))}
          </div>
        </div>
      )}
    </div>
  );
};

export default React.memo(FaqAccordion);
